import { render, staticRenderFns } from "./groupCompetition.vue?vue&type=template&id=155d48df&scoped=true"
import script from "./groupCompetition.vue?vue&type=script&lang=js"
export * from "./groupCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d48df",
  null
  
)

export default component.exports